import React from 'react';
import AdvertiserSessionsLoader from '../../../../../core/components/advertiser/advertiserdetails/sessions/AdvertiserSessionsLoader';
import AdvertiserSessionsController from '../../../../../core/components/advertiser/advertiserdetails/sessions/AdvertiserSessionsController';
import DetailBar from '../components/DetailBar';
import DualAxisChart from '../../../../shared/charts/DualAxisChart';
import { summaryScale } from '../../utils/summaryScale';
import moment from 'moment';
import { Col, Row } from 'antd';
import SessionsTable from '../components/SessionsTable';
import SessionDeviceBreakdown from '../components/SessionDeviceBreakdown';
import TopCreatives from '../components/TopCreatives';
import TopImpressionDomains from '../components/TopImpressionDomains';
import TopInventoryTypes from '../components/TopInventoryTypes';
import { LoadingPage } from '../../../../shared/LoadingPage';

const SessionsDetailsView = ({ setRefSignUps, ...props }) => {
  return (
    <AdvertiserSessionsLoader {...props}>
      <AdvertiserSessionsController {...props}>
        <SessionsTab setRefSignUps={setRefSignUps} {...props} />
      </AdvertiserSessionsController>
    </AdvertiserSessionsLoader>
  );
};

const SessionsTab = ({
  reportDataSummary,
  advertiser,
  setRefSignUps,
  changeDatePicker,
  reportDataSummaryLoading,
  topCreatives,
  topImpressions,
  topInventoryTypes,
}) => {
  const dropDownOptions = [
    { key: 'sessions', display: 'Sessions' },
    { key: 'attributedImpressions', display: 'Attributed Impressions' },
    { key: 'pageViews', display: 'Page Views' },
    { key: 'totalImpressions', display: 'Impressions' },
  ];

  if (reportDataSummaryLoading) return <LoadingPage />;
  return (
    <>
      <DetailBar
        totalImpressions={advertiser.totalImpressions}
        {...reportDataSummary}
        startDate={advertiser.startDate}
        endDate={advertiser.endDate}
        module="SESSIONS"
      />
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <DualAxisChart
            byDate={reportDataSummary?.byDate || []}
            xAxis="date"
            setRefSignUps={setRefSignUps}
            options={dropDownOptions}
            defaultLeftYValue={dropDownOptions[0]}
            defaultRightYValue={dropDownOptions[1]}
            customScale={summaryScale}
            onDatePickerChange={({ data, dates, rangeKey }) => {
              changeDatePicker(dates);
            }}
            has6MonDisables={false}
            allTimeDateRange={[moment(advertiser.startDate), moment(advertiser.endDate)]}
          />
        </Col>
        <Col span={24}>
          <SessionDeviceBreakdown
            data={reportDataSummary ? reportDataSummary.deviceBreakdown : null}
          />
        </Col>
        <Col xs={24}>
          <SessionsTable data={reportDataSummary ? reportDataSummary.sessionList : []} />
        </Col>
        <Col xs={24}>
          <TopCreatives data={topCreatives} countKey="sessions" countLabel="Sessions" />
        </Col>
        <Col xs={24}>
          <TopImpressionDomains data={topImpressions} countKey="sessions" countLabel="Sessions" />
        </Col>
        <Col xs={24}>
          <TopInventoryTypes data={topInventoryTypes} countKey="sessions" countLabel="Sessions" />
        </Col>
      </Row>
    </>
  );
};

export default SessionsDetailsView;
